import { render, staticRenderFns } from "./SUBJECTDL.vue?vue&type=template&id=c07ac27c&"
import script from "./SUBJECTDL.vue?vue&type=script&lang=js&"
export * from "./SUBJECTDL.vue?vue&type=script&lang=js&"
import style0 from "./SUBJECTDL.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports